import { render } from "./sweeper.vue?vue&type=template&id=3858a2ae&scoped=true"
import script from "./sweeper.vue?vue&type=script&lang=js"
export * from "./sweeper.vue?vue&type=script&lang=js"

import "./sweeper.vue?vue&type=style&index=0&id=3858a2ae&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3858a2ae"]])

export default __exports__